import React from "react";
import { Card } from "semantic-ui-react";
import { COMPANY_EMAIL } from "../../shared/Literals";
import cc_by_logo from "../../images/cc_by_logo.avif";

const Contact = () => {
	return (
		<Card fluid>

			<Card.Content>
				<h4 className="title-card">Contribute</h4>
			</Card.Content>
			<Card.Content>
				<p>
					You can suggest a study to be added to the ESVD using the “Suggest a
					Study” page. Suggested studies will be added to the repository of
					valuation studies to be analysed, entered into the database, reviewed
					and shared through the ESVD.{" "}
				</p>
				<br />
			</Card.Content>

			<Card.Content>
				<h4 className="title-card">Contact</h4>
			</Card.Content>
			<Card.Content>
				<p>
					Want to stay informed?{" "}
					<a
						className="esvd-hyperlink"
						href="https://www.es-partnership.org/sign-up/"
						target="_blank"
						rel="noopener noreferrer">
						Subscribe for the monthly Ecosystem Services Partnership Update.
					</a>{" "}
				</p>
				<p>
					The ESVD is Open Source and voluntary contributions are much
					appreciated to maintain and further improve the database.
					Contributions can help us expand the database to cover more biomes and
					regions as well as to further develop the database functionalities.{" "}
					<a
						className="esvd-hyperlink"
						href="https://esvd.info"
						target="_blank"
						rel="noopener noreferrer">
						Visit our info website
					</a>{" "}
					if you wish to contribute to the development of ESVD.
				</p>
				<p>
					Any questions? Send us an{" "}
					<a className="esvd-hyperlink" href={`mailto:${COMPANY_EMAIL}`}>
						email
					</a>
					.
				</p>
				<br />
			</Card.Content>

			<Card.Content>
				<h4 className="title-card">License</h4>
			</Card.Content>
			<Card.Content>
				<p>
						Content from ESVD is licensed under Creative Commons Attribution-NonCommercial 4.0 International {" "}
							<a className="esvd-hyperlink" href="https://creativecommons.org/licenses/by-nc/4.0/" target="_blank" rel="noopener noreferrer">
								(CC BY-NC 4.0)
							</a>							
						
					<br/>
					<br/>
					<img
						src={cc_by_logo}
						alt="logo"
						style={{
							height: "auto",
							minWidth: "20%",
							width: "20%",
							backgroundSize: "contain",
							outline: "none",
							border: "none",
							paddingTop: ".5em",
						}}
					/>					
				</p>
			</Card.Content>			
		</Card>
	);
};

export default Contact;
